export default __webpack_public_path__ + "static/media/gerhard.a3b3203f.png";